import * as queries from '../queries'
import { IsEmailAlreadyTakenQuery } from '../remotequeries';
import { trelloStore, StoreScope, StoreType } from '../../services/trellostore';
import StoreKeys from '../../services/storekeys'
import channel from '../../cqs/channel';

import config from '../../services/config';



export var GetSetupQueryHandler = (t: ITrelloClient, n: queries.GetSetupQuery) : Promise<queries.GetSetupQueryResult> => {
    return new Promise(resolve => {
        config(t).get().then(cfg => {
            if (cfg == undefined) {
                cfg = config(t).getDefaultConfigObject(undefined);
            }
            resolve(new queries.GetSetupQueryResult(
                cfg.isShowEstimation,
                cfg.isShowEstimationOnCardFront,
                cfg.isShowEstimationOnCardBack,

                cfg.isEnableEditEstimation,
                cfg.storyPointScale,
                cfg.isStoryPointScaleValueCustomizable,
                cfg.isMarkBigStoryCards,
                cfg.bigStoryLimit,

                cfg.isShowStoryAttachemtns,

                cfg.isShowReleases,
                cfg.isShowReleasesOnCardFront,
                cfg.isShowReleasesOnCardBack,

                cfg.isShowCardContext,
                cfg.isShowCardContextGoalOnCardFront,
                cfg.isShowCardContextStepOnCardFront,
                cfg.isShowCardContextOnCardBack,

                cfg.isShowAnnotations,
                cfg.isShowAnnotationsOnCardFront,
                cfg.isShowAnnotationsOnCardBack,
                cfg.selectedAnnoatations
            ));
        });
    });
}

export const IsEmailAlreadyTakenQueryHandler = async (t: ITrelloClient, q: queries.IsEmailAlreadyTakenQuery): Promise<boolean> => {
    var result: boolean = await channel(t).executeQuery(new IsEmailAlreadyTakenQuery(q.emailAddress));

    return result;
}
